const GET_BADGES_LIST = 'dofe-bo/badges/GET_BADGES_LIST'
const GET_BADGES_LIST_SUCCESS = 'dofe-bo/badges/GET_BADGES_LIST_SUCCESS'
const GET_BADGES_LIST_FAIL = 'dofe-bo/badges/GET_BADGES_LIST_FAIL'

const GET_BADGES_PROGRESS = 'dofe-bo/badges/GET_BADGES_PROGRESS'
const GET_BADGES_PROGRESS_SUCCESS = 'dofe-bo/badges/GET_BADGES_PROGRESS_SUCCESS'
const GET_BADGES_PROGRESS_FAIL = 'dofe-bo/badges/GET_BADGES_PROGRESS_FAIL'

const GET_AWARD_BADGES_LIST = 'dofe-bo/badges/GET_AWARD_BADGES_LIST'
const GET_AWARD_BADGES_SUCCESS = 'dofe-bo/badges/GET_AWARD_BADGES_SUCCESS'
const GET_AWARD_BADGES_FAIL = 'dofe-bo/badges/GET_AWARD_BADGES_FAIL'

const initialState = {
    badges: [],
    awardBadges: [],
    badgesProgress: {},
    default: [],
    isLoading: false,
    loaded: false
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_BADGES_LIST:
            return {
                ...state,
                isLoading: true
            }
        case GET_BADGES_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                loaded: true,
              badges: action.result
            }
        case GET_BADGES_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                loaded: false
            }
      case GET_AWARD_BADGES_LIST:
        return {
          ...state,
          isLoading: true
        }
      case GET_AWARD_BADGES_SUCCESS:
        return {
          ...state,
          isLoading: false,
          loaded: true,
          awardBadges: action.result
        }
      case GET_AWARD_BADGES_FAIL:
        return {
          ...state,
          isLoading: false,
          loaded: false
        }
      case GET_BADGES_PROGRESS:
        return {
          ...state,
          isLoading: true
        }
      case GET_BADGES_PROGRESS_SUCCESS:
        return {
          ...state,
          isLoading: false,
          loaded: true,
          badgesProgress: action.result
        }
      case GET_BADGES_PROGRESS_FAIL:
        return {
          ...state,
          isLoading: false,
          loaded: false
        }
        default:
            return state
    }
}

export function getBadges(mergeGroups = false, cfgOrganizationId = 0) {
  const readConfigParams = cfgOrganizationId ? `&with=BADGE_IMAGES,BADGE_CONFIGURATION&cfgOrganizationId=${cfgOrganizationId}` : ''

    return {
        types: [GET_BADGES_LIST, GET_BADGES_LIST_SUCCESS, GET_BADGES_LIST_FAIL],
        promise: client => client.get(`api/badges/list?mergeGroups=${mergeGroups}${readConfigParams}`)
    }
}

export function getBadgesProgress(awardId = 0) {
    return {
      types: [GET_BADGES_PROGRESS, GET_BADGES_PROGRESS_SUCCESS, GET_BADGES_PROGRESS_FAIL],
      promise: client => client.get(`api/badges/progress?awardId=${awardId}`)
    }
}

export function getAwardBadges(awardId) {
  return {
    types: [GET_AWARD_BADGES_LIST, GET_AWARD_BADGES_SUCCESS, GET_AWARD_BADGES_FAIL],
    promise: client => client.get(`api/award-badges/list?with=BADGE_IMAGES,BADGE,BADGE_CONFIGURATION,ORGANIZATION&award.id=${awardId}`)
  }
}


